import { initClientKillSwitch, PlatformName } from '@cbhq/client-kill-switch';
import type { ValidatedKillSwitchConfig } from '@cbhq/identity-shared';

import { targetEnvironment, unifiedLoginUrl } from '../../configs/environments';

export const workspaceKillSwitchConfig = {
  t0018_8e42f55c: false, // workspace team redirect
};

export const workspaceDefaultClientKillSwitchConfig =
  workspaceKillSwitchConfig satisfies ValidatedKillSwitchConfig<typeof workspaceKillSwitchConfig>;

export const killswitchConfig = {
  serviceUrl: `${unifiedLoginUrl}/v3/coinbase.killswitch.KillSwitchService/KillSwitches`,
  disabled: targetEnvironment === 'local',
  scope: 'identity-frontend',
  platform: PlatformName.web,
  version: '',
};

export async function initKillSwitches() {
  return initClientKillSwitch(workspaceDefaultClientKillSwitchConfig, killswitchConfig);
}
